import React, { useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { createCustomTheme } from '@muilocal/theme';
import { getPrimaryColor, getFontFamily } from '@utils/embedSettings';

interface MuiThemeProviderProps {
  children: React.ReactNode;
}

const MuiThemeProvider = ({ children }: MuiThemeProviderProps) => {
  // Read primaryColor and fontFamily from URL query parameters or localStorage
  const { primaryColor, fontFamily } = useMemo(() => {
    if (typeof window === 'undefined') return { primaryColor: undefined, fontFamily: undefined };
    const params = new URLSearchParams(window.location.search);
    return {
      primaryColor: getPrimaryColor(params),
      fontFamily: getFontFamily(params),
    };
  }, []);

  // Create theme with custom primary color and font family if provided
  const theme = useMemo(() => createCustomTheme(primaryColor, fontFamily), [primaryColor, fontFamily]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CssBaseline />
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default MuiThemeProvider;
